import { createContext, useContext } from 'react';

export type AppThemeMode = 'light' | 'dark';

interface ThemeModeContextValue {
  mode: AppThemeMode;
  toggleMode: () => void;
}

export const ThemeModeContext = createContext<ThemeModeContextValue>({
  mode: 'light',
  toggleMode: () => {},
});

export const useThemeMode = () => useContext(ThemeModeContext);
